import { render, staticRenderFns } from "./CatalogEdit.vue?vue&type=template&id=baa5a590&scoped=true&"
import script from "./CatalogEdit.vue?vue&type=script&lang=js&"
export * from "./CatalogEdit.vue?vue&type=script&lang=js&"
import style0 from "./CatalogEdit.vue?vue&type=style&index=0&id=baa5a590&prod&scoped=true&lang=css&"
import style1 from "./CatalogEdit.vue?vue&type=style&index=1&id=baa5a590&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa5a590",
  null
  
)

export default component.exports